import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import Mundo from '@catalogo/ui-americanas-desktop-svg/icon-mundo-airplane.svg';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const InternationalMessage = ({ history }) => (
  <Wrapper>
    <MundoWrapper>
      <MundoUI width="110" height="30" />
      <strong>Produto Internacional</strong>
    </MundoWrapper>
    <p>
      Produtos do <strong>mundo todo</strong> com entrega para todo o Brasil{' '}
      <Link onClick={replaceUrlParams(history, '#modal-mundo-info-spacey', false)}>saiba mais</Link>
    </p>
  </Wrapper>
);

const MundoUI = styled(Mundo)`
  margin-right: 15px;
`;

const Link = styled.span`
  text-decoration: underline;
`;

const MundoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 5px;
`;

const Wrapper = styled.div`
  padding-top: 30px;
  margin-top: 30px;
  width: 100%;
  font-size: 14px;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
  background: #fff;
  -webkit-font-smoothing: antialiased;
  color: #666;
`;

export default withRouter(InternationalMessage);
